import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import Button from "@components/ButtonComponent";
import { Input } from "@/components/ui/input";

const DateNavigationSection = ({
  selectedBusinessDay,
  tempBusinessDay,
  setTempBusinessDay,
  setSelectedBusinessDay,
  setDebouncedBusinessDay,
  formatDate,
  getPreviousDay,
  getNextDay,
  navigateToDate,
}) => {
  return (
    <div className="flex flex-col sm:flex-row items-center gap-4 p-2 py-2 dark:bg-gray-700 dark:border-gray-500 bg-white/60 rounded-xl border border-modern-light shadow-subtle">
      <Button
        variant="outline"
        onClick={() => navigateToDate("prev")}
        disabled={!selectedBusinessDay}
        icon={<ChevronLeft className="h-4 w-4" />}
        noTextSwap={true}
      >
        <span className="text-sm font-medium">
          {selectedBusinessDay
            ? formatDate(getPreviousDay(selectedBusinessDay))
            : ""}
        </span>
      </Button>

      <div className="flex items-center space-x-3 gap-2">
        <div className="flex flex-col space-x-3">
          <div className="flex items-center space-x-3">
            <span className="text-xs min-w-21 font-semibold dark:text-white text-gray-700 whitespace-nowrap">
              {`Business Day:`}
            </span>
            <Input
              type="date"
              value={
                tempBusinessDay !== null
                  ? tempBusinessDay
                  : selectedBusinessDay || ""
              }
              onChange={(e) => {
                // Store temporary selection - don't apply yet
                if (e.target.value && e.target.value.length === 10) {
                  setTempBusinessDay(e.target.value);
                } else {
                  setTempBusinessDay(null);
                }
              }}
              className="text-slate-900 dark:text-white font-semibold border-primary-200 focus:border-primary-400 focus:ring-primary-100 transition-all duration-200"
            />
          </div>
          {/* Show Apply/Cancel buttons when a valid temporary date is selected */}
          {tempBusinessDay !== null &&
            tempBusinessDay.length === 10 &&
            tempBusinessDay !== selectedBusinessDay && (
              <div className="flex gap-2 justify-end mt-2">
                <Button
                  variant="outline"
                  type="cancel"
                  width="max"
                  color="red"
                  size="sm"
                  withoutborder={true}
                  noTextSwap={true}
                  onClick={() => {
                    setTempBusinessDay(null);
                  }}
                >
                  {`Cancel`}
                </Button>
                <Button
                  color="green"
                  noTextSwap={true}
                  size="sm"
                  withoutborder={true}
                  width="max"
                  onClick={() => {
                    // Only apply if a date has been selected
                    if (
                      tempBusinessDay &&
                      tempBusinessDay.length === 10
                    ) {
                      setSelectedBusinessDay(tempBusinessDay);
                      setDebouncedBusinessDay(tempBusinessDay);
                      setTempBusinessDay(null);
                    }
                  }}
                >
                  {`Apply`}
                </Button>
              </div>
            )}
        </div>
      </div>

      <Button
        variant="outline"
        onClick={() => navigateToDate("next")}
        disabled={!selectedBusinessDay}
        icon={
          <span className="text-sm font-medium">
            {selectedBusinessDay
              ? formatDate(getNextDay(selectedBusinessDay))
              : ""}
          </span>
        }
        noTextSwap={true}
      >
        <ChevronRight className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default DateNavigationSection;
